import { Classroom } from 'types/classroom';
import { CJEDTEvent } from 'types/event';

export function addClassroomOrderToSeances(
  seances: CJEDTEvent[],
  classrooms: Classroom[],
) {
  if ((classrooms || []).length === 0) {
    return seances;
  }
  return seances.map(seance => {
    if ((seance.classroomIds || []).length === 0) {
      return seance;
    }
    const classroom = classrooms.find(cl => cl.id === seance.classroomIds[0]);
    return {
      ...seance,
      classroomOrder: classroom?.order ?? 0,
    };
  });
}
